import { styled, Tab as MuiTab, Tabs as MuiTabs } from "@mui/material";
export const Tabs = styled(MuiTabs, {
    shouldForwardProp: (property) => property !== "primary",
})(({ primary }) => ({
    "& .MuiTabs-indicator": {
        backgroundColor: primary ? "#00A555" : "#6BB1E3",
        height: primary ? "2px" : "4px",
    },
}));
export const Tab = styled(MuiTab, {
    shouldForwardProp: (property) => property !== "primary",
})(({ theme, primary }) => ({
    textTransform: "none",
    fontWeight: primary
        ? theme.typography.fontWeightBold
        : theme.typography.fontWeightRegular,
    color: primary ? "#888F97" : "#000",
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    "&.Mui-selected": {
        fontWeight: theme.typography.fontWeightBold,
        color: primary ? "#00A555" : "#000",
    },
    "&.Mui-focusVisible": {
        backgroundColor: primary ? "#00A555" : "#6BB1E3",
    },
}));
